// ─────────────────────────────────────────────────────────────────────────────
// Location Shipping Exclusions Selectors
// ─────────────────────────────────────────────────────────────────────────────
// NgRx selectors for the locationShippingExclusions store slice (WB-7570).
// ─────────────────────────────────────────────────────────────────────────────

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LocationShippingExclusionsState } from './location-shipping-exclusions.reducers';

// ── Feature selector ─────────────────────────────────────────────────────────

export const selectLocationShippingExclusions = createFeatureSelector<LocationShippingExclusionsState>('locationShippingExclusions');

// ── Basic selectors ──────────────────────────────────────────────────────────

export const selectLocationShippingExclusionItems = createSelector(selectLocationShippingExclusions, (state) => state.items);
export const selectLocationShippingExclusionLoading = createSelector(selectLocationShippingExclusions, (state) => state.loading);
export const selectLocationShippingExclusionCreating = createSelector(selectLocationShippingExclusions, (state) => state.creating);
